import React from 'react'
import {
  Box,
  Typography,
  Chip,
  Link,
  Grid,
  makeStyles,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import { SemiConfigFormValues } from '../ProductsConfiguration'
import router, { useRouter } from 'next/router'
import { ActiveLinkType } from '../enum'

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(8),
  },

  title: {
    marginBottom: theme.spacing(6),
  },

  chipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  chip: {
    backgroundColor: '#E2F4FF',
    color: '#1976d2',
    border: '1px solid #0F69AF',
    borderRadius: '3px',
    '& .MuiChip-label': {
      fontSize: '0.75rem',
      fontWeight: 500,
    },
  },
  clearAllLink: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: '0.875rem',
  },
}))

const SearchTerms: React.FC<{}> = () => {
  const classes = useStyles()
  const formik = useFormikContext<SemiConfigFormValues>()

  const { query } = useRouter()
  const searchTerm = formik.values.searchData.searchKey
  const formattedSearchTerm = searchTerm
    .trim()
    .replace(/[/\n+\s]/g, ',')
    .replace(/,+/g, ',')

  const searchTerms = formattedSearchTerm
    ?.split(',')
    ?.map((item) => item?.trim())

  const handleDeleteTerm = (index: number) => {
    if (searchTerms.length === 1) {
      formik.setFieldValue('searchData.searchKey', '', false)
      formik.setFieldValue('completedStep', 0, false)
      router.push(
        {
          pathname: router.pathname,
          query: {
            country: query.country,
            language: query.language,
            activeLink: ActiveLinkType.ProductSearch,
          },
        },
        undefined,
        { shallow: true }
      )
    } else {
    }
    const updatedSearchTerm = searchTerms.filter((_, i) => i !== index)
    formik.setFieldValue(
      'searchData.searchKey',
      updatedSearchTerm.join(' '),
      false
    )
  }

  const handleClearAll = () => {
    formik.setFieldValue('searchData.searchKey', '', false)
    formik.setFieldValue('completedStep', 0, false)
    router.push(
      {
        pathname: router.pathname,
        query: {
          country: query.country,
          language: query.language,
          activeLink: ActiveLinkType.ProductSearch,
        },
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.title}>
        <Typography variant="h3">
          <FormattedMessage id="SEARCH_TERMS" defaultMessage="Search Terms" />
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box className={classes.chipsContainer}>
          {searchTerms.map((term, index) => (
            <Chip
              key={`${term}-${index}`}
              label={term}
              deleteIcon={
                <span
                  style={{
                    color: '#0F69AF',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    lineHeight: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  ×
                </span>
              }
              onDelete={() => handleDeleteTerm(index)}
              className={classes.chip}
              size="small"
            />
          ))}

          {searchTerms.length > 0 && (
            <Link onClick={handleClearAll} className={classes.clearAllLink}>
              <FormattedMessage id="CLEAR_ALL" defaultMessage="Clear All" />
            </Link>
          )}
        </Box>
      </Grid>
    </Grid>
  )
}

export default SearchTerms
